<template>
	<div class="degree-table-row">
		<div class="tw-flex degree-table-header">
			<div class="tw-w-9/12 tw-flex">
				<div class="degree-table-row-interactions tw-flex tw-items-center">
					<div class="drag-handler">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<v-checkbox
						class="custom-checkbox"
						color="primary"
						v-model="checkModel"
						@change="checkChanged"
						:checked="true"
					/>
				</div>
				<div class="tw-flex tw-flex-auto tw-justify-between tw-items-center">
					<span class="text-info">{{ degree.name }}</span>
					<div class="tw-flex">
						<div class="tw-mr-4">
							<span v-if="isPgMax" class="degree-table-row-pg-tag text-primary font-weight-bold">PGM</span>
							<span v-if="isPgMin" class="degree-table-row-pg-tag text-primary font-weight-bold">PGm</span>
						</div>
						<edit-icon color="secondary" class="tw-mr-2  cursor-pointer" @click="$emit('onEditClick', degree)" />
						<trash-icon class="cursor-pointer" @click="$emit('onDeleteClick', degree)" />
					</div>
				</div>
			</div>
			<div class="tw-w-3/12 tw-text-center">
				<span class="text-info text-2xl font-weight-bold">{{ degree.rate || 0 }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import EditIcon from '@/modules/shared/components/icons/edit-icon';
import TrashIcon from '@/modules/shared/components/icons/trash-icon';

export default {
	name: 'DegreeTableRow',
	components: { TrashIcon, EditIcon },
	props: ['degree', 'checked', 'isPgMax', 'isPgMin'],
	data() {
		return {
			checkModel: false,
		};
	},
	methods: {
		checkChanged(checked) {
			this.$emit('onCheckedChange', { degree: this.degree, checked });
		},
	},
	watch: {
		checked: {
			handler(value) {
				this.checkModel = value;
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.degree-table-row {
	border-bottom: 1px solid var(--app-color-gray);
	padding: 10px;
	&:last-child {
		border-bottom: none;
	}
	.degree-table-row-interactions {
		width: 70px;
	}
	.drag-handler {
		height: 20px;
		cursor: move;
		padding-right: 5px;
		margin-right: 10px;
		span {
			display: flex;
			height: 6px;
			justify-content: center;
			align-items: center;
			&:before, &:after {
				content: '';
				width: 3px;
				height: 3px;
				background-color: var(--app-color-gray);
				display: inline-block;
				border-radius: 50%;
			}
			&:before {
				margin-right: 4px;
			}
			&:after {
			}
		}
	}
	.degree-table-row-pg-tag {
		padding: 5px 10px;
		border-radius: 20px;
		background-color: #ececec;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreeTableRow.vue